import { BASE_URL_ARCHIVE } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_ARCHIVE}/press-review-archived`

export const ARCHIVE_PRESS_REVIEW_ARCHIVED: Route = {
  path: base
}

export const ARCHIVE_PRESS_REVIEW_ARCHIVED_VIEW: Route = {
  path: `${base}/customer/{id_customer}/press-review/{id}`
}

export const ARCHIVE_PRESS_REVIEW_ARCHIVED_CUSTOMER: Route = {
  path: `${base}/customer/{id}`
}

export const ARCHIVE_PRESS_REVIEW_ARCHIVED_CUSTOMER_GO_TO_FIRST_WITH_DATE: Route = {
  path: `${base}/customer/{id}?go_to_first=1&date={date}`
}

export const ARCHIVE_PRESS_REVIEW_ARCHIVED_CUSTOMER_FROM_PRESS_REVIEW_ISSUE_WITH_DATE: Route = {
  path: `${base}/customer/{id}?from_press_review_issue_id={id_press_review_issue}&date={date}`
}
